import { getEnvValue } from '@/utils/env-config';

const DEFAULT_X_HEADER = {
  "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
};

const DEFAULT_JSON_HEADER = {
  "Content-Type": "application/json",
};

const BASE_URL = getEnvValue('BASE_USER_API', 'VUE_APP_BASE_USER_API');

export const baseSource = "";

export default {
  url: BASE_URL,
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    ...DEFAULT_X_HEADER,

    "Accept-Language": "zh, en-US; q=0.9, en; q=0.8",
    "X-Requested-With": "XMLHttpRequest",
  },
};

export const APPLICATION_JSON = DEFAULT_JSON_HEADER;
